"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }

var _actionCreators = require('shared/actions/actionCreators'); var _actionCreators2 = _interopRequireDefault(_actionCreators);
var _myMetadata = require('shared/services/myMetadata');
var _pins = require('shared/services/pins');
















const initialState = {}

// A row whose failure count the server couldn't read keeps the last one, as
// does every row of a reply that never carries the count (GetBlobjectDeep).
const withKnownFailures = (state, incoming, carriesCount = true) => {
  let merged = null
  for (const [key, blobject] of Object.entries(incoming) ) {
    const previous = state[key]
    if (!blobject || !previous || (carriesCount && !blobject.ScheduledFailuresUnknown)) continue
    merged = merged || { ...incoming }
    merged[key] = {
      ...blobject,
      ScheduledFailures: previous.ScheduledFailures,
      ScheduledFailureLatestAt: previous.ScheduledFailureLatestAt,
    }
  }
  return merged || incoming
}

const withMySeenTime = (state, incoming, myUserKey) => {
  let merged = null
  for (const [key, blobject] of Object.entries(incoming) ) {
    const kept = _myMetadata.withFresherMyMetadata.call(void 0, state[key], blobject, myUserKey)
    if (kept === blobject) continue
    merged = merged || { ...incoming }
    merged[key] = kept
  }
  return merged || incoming
}

const withMyMark = (state, blobjectKey, myUserKey, MarkedUnread) => {
  const blobject = state[blobjectKey]
  const mine = _optionalChain([blobject, 'optionalAccess', _ => _.UserMetadata, 'optionalAccess', _2 => _2[myUserKey]])
  if (!blobject || !mine || !!(mine ).MarkedUnread === MarkedUnread) return state
  return {
    ...state,
    [blobjectKey]: { ...blobject, UserMetadata: { ...blobject.UserMetadata, [myUserKey]: { ...mine, MarkedUnread } } },
  }
}

const PIN_PHASES = {
  [_actionCreators2.default.setBlobjectPinnedActions.REQUEST.type]: 'request',
  [_actionCreators2.default.setBlobjectPinnedActions.SUCCESS.type]: 'success',
  [_actionCreators2.default.setBlobjectPinnedActions.FAILURE.type]: 'failure',
}

// A team chat I've never opened has no metadata of mine yet; pinning starts it.
const withMyPin = (state, blobjectKey, myUserKey, PinnedAt) => {
  const blobject = state[blobjectKey]
  const mine = _optionalChain([blobject, 'optionalAccess', _3 => _3.UserMetadata, 'optionalAccess', _4 => _4[myUserKey]]) 
  if (!blobject || (_optionalChain([mine, 'optionalAccess', _5 => _5.PinnedAt]) || null) === PinnedAt) return state
  return {
    ...state,
    [blobjectKey]: { ...blobject, UserMetadata: { ...blobject.UserMetadata, [myUserKey]: { ...mine, PinnedAt } } },
  }
}

 function blobjectReducer (
  state = initialState,
  action,
  globalStateV2,
) {
  let blobjectKey = null
  let newState = null

  switch (action.type) {
    case _actionCreators2.default.getInboxActions.SUCCESS.type:
    case _actionCreators2.default.getInboxForUserActions.SUCCESS.type:
    case _actionCreators2.default.getInboxForPatientActions.SUCCESS.type:
    case _actionCreators2.default.updateNotificationAction.type: {
      const payload = action.payload 
      if (!payload.Blobjects) return state
      const incoming = withMySeenTime(state, payload.Blobjects, globalStateV2.currentUser.UserKey)
      return { ...state, ...withKnownFailures(state, incoming) }
    }

    case _actionCreators2.default.markBlobjectSeenActions.REQUEST.type: {
      const { payload } = action 
      if (!payload.BKey) {
        return state
      }

      // An unknown key yields a partial blobject, as in the JS.
      const stateBlobject = state[payload.BKey] || {} 
      const stateUserMetadata = stateBlobject.UserMetadata || {}
      const myUserKey = globalStateV2.currentUser.UserKey
      return {
        ...state,
        [payload.BKey]: {
          ...stateBlobject,
          UserMetadata: {
            ...stateUserMetadata,
            [myUserKey]: {
              ...stateUserMetadata[myUserKey],
              // SAFETY: unchecked. Callers send the message's ISO string, but
              // markBlobjectSeen (actions/inbox) substitutes a Date for an empty
              // one, which is then stored as received, as in the JS.
              SeenTime: _myMetadata.laterSeenTime.call(void 0, 
                _optionalChain([stateUserMetadata, 'access', _6 => _6[myUserKey], 'optionalAccess', _7 => _7.SeenTime]),
                (payload.SeenTime || new Date().toISOString()) ,
              ),
              // Marking seen clears "Mark as unread", as on the server.
              MarkedUnread: false,
            },
          },
        } ,
      }
    }
    case _actionCreators2.default.markBlobjectUnreadActions.REQUEST.type: {
      const { payload } = action 
      return withMyMark(state, payload.BKey, globalStateV2.currentUser.UserKey, true)
    }
    // Only read rows offer "Mark as unread", so a failed mark turns it read.
    case _actionCreators2.default.markBlobjectUnreadActions.FAILURE.type: {
      const { meta } = action 
      return withMyMark(state, meta.BKey, globalStateV2.currentUser.UserKey, false)
    }
    // Unpin shows at once, Pin at once or, near the limit, once the server
    // takes it (pinnedAtAfter); a failed command puts the old pin back.
    case _actionCreators2.default.setBlobjectPinnedActions.REQUEST.type:
    case _actionCreators2.default.setBlobjectPinnedActions.SUCCESS.type:
    case _actionCreators2.default.setBlobjectPinnedActions.FAILURE.type: {
      const { meta } = action 
      const PinnedAt = _pins.pinnedAtAfter.call(void 0, PIN_PHASES[action.type], meta)
      return PinnedAt === undefined ? state : withMyPin(state, meta.BKey, globalStateV2.currentUser.UserKey, PinnedAt)
    }
    /* TODO: a REFRESH message here (needs backend) as opposed to an update */
    case _actionCreators2.default.getBlobjectDeepActions.SUCCESS.type: {
      const incoming = withMySeenTime(
        state,
        (action.payload ).Blobjects || {},
        globalStateV2.currentUser.UserKey,
      )
      return { ...state, ...withKnownFailures(state, incoming, false) }
    }
    case _actionCreators2.default.renameChatActions.REQUEST.type: {
      const { payload } = action 
      const name = payload.Name
      blobjectKey = payload.BKey

      return {
        ...state,
        // An unknown key yields { Name } only, as in the JS.
        [blobjectKey]: {
          ...state[blobjectKey],
          Name: name,
        } ,
      }
    }
    case _actionCreators2.default.purgeNotificationAction.type: {
      const { payload } = action 
      if (!payload.Blobjects) return state

      newState = { ...state }
      payload.Blobjects.forEach((b) => {
        delete newState[b]
      })

      return newState
    }
    case _actionCreators2.default.logoutAction.type:
      return initialState
  }
  return state
} exports.default = blobjectReducer;
